import { render } from "./faq.html?vue&type=template&id=f20f5e26&external"
import script from "./faq.js?vue&type=script&lang=js&external"
export * from "./faq.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__